/* Component Dependencies */
var discoverDestinationTemplate = require('templates/discoverDestination.hbs');
var AriesComponent = require('libs/aries-component');
require('libs/jquery.dotdotdot');

AriesComponent.create({
  type: 'discoverDestination',
  template: {
    'discoverDestination': discoverDestinationTemplate
  },

  events: {
    'click .js-action-label': 'toggleHandler'
  },

  bindEvents: function () {
    var articleContent = this.$el.find('.js-article-content');
    if(articleContent.data('collapse')) {
      articleContent.addClass('l-collapsed');
      this.applyEllipsis(articleContent);
    }
  },

  /**
   * This function is executed when read-more or read-less is clicked
   */
  toggleHandler: function _toggleHandler(event) {
    event.preventDefault();
    var currTarget = $(event.currentTarget),
      currLabel = currTarget.find('.t-caption-label'),
      articleContent = this.$el.find('.js-article-content');
    currTarget.find('.t-caption-icon').toggleClass('t-icon-arrow-down t-icon-arrow-up');
    articleContent.toggleClass('l-collapsed l-expand');
    if (articleContent.hasClass('l-expand')) {
      currLabel.html(currTarget.data('label-collapse'));
      articleContent.html(articleContent.data('description'));
    }
    else {
      currLabel.html(currTarget.data('label-expand'));
      this.applyEllipsis(articleContent);
    }
  },

  /**
   * This functions applies dotdotdot
   * @param jqueryElement on which dotdotplugin applied
   * @returns boolean true
   */
  applyEllipsis: function _applyEllipsis($articleContent) {
    $articleContent.find('p').each(function (index, item) {
      if (!index) {
        $articleContent.find('p:first-child').dotdotdot();
      } else {
        $(item).addClass('is-hidden');
      }
    });
    return true;
  }
});